import KAddressInput from 'app/components/Modules/Form/KAddressInput'
import KInputText from 'app/components/Modules/Form/KInputText'
import KNestedFields from 'app/components/Modules/Form/KNestedFields'
import Button from 'app/components/UI-Elements/General/Button'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { useKFormContext } from 'app/lib/contexts/KFormContext'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { attributeNames } from 'app/lib/utils/delivery-address'
import { RecordTypeEnum } from 'app/queries'
import React from 'react'

import DeliveryAddressAlert from '../Hint'
import useZipValidation from '../hooks/useZipValidation'
import DeliveryAddressMap from '../Map'

type Props = {
  showAvailabilityHint?: boolean
  initialDeliveryZip?: string
  searchExtra?: React.ReactNode
}

const AddressInputs: React.FC<Props> = ({
  showAvailabilityHint,
  initialDeliveryZip,
  searchExtra
}) => {
  const {
    modalify: { open, close }
  } = useFeedbacker()
  const { tRecordType } = ToolBox.useString()
  const { form } = useKFormContext()
  const { zipHasChanged, inputProps } = showAvailabilityHint
    ? useZipValidation({ initialDeliveryZip })
    : { zipHasChanged: false, inputProps: undefined }

  const title = tRecordType(RecordTypeEnum.rentalDeliveryAddress, 'edit')

  const onFinish = (address: IAddress) => {
    form.setFieldsValue(address)
    form.validateFields()
    close()
  }

  const openDraggableMap = () => {
    open({
      title,
      recordType: RecordTypeEnum.rentalDeliveryAddress,
      destroyOnClose: true,
      modalType: 'form',
      width: 1000,
      content: (
        <DeliveryAddressMap
          initialValues={form.getFieldsValue()}
          onCancel={close}
          onFinish={onFinish}
          names={attributeNames}
        />
      )
    })
  }

  return (
    <KAddressInput
      names={attributeNames}
      required
      defaultExpand
      showMap
      name={'addressSummary'}
      searchExtra={searchExtra}
      mapProps={{
        button: <Button type="secondary" title={title} onClick={openDraggableMap} />
      }}
      inputProps={inputProps}>
      <If condition={zipHasChanged}>
        <DeliveryAddressAlert />
      </If>
      <KInputText name="longitude" hidden />
      <KInputText name="latitude" hidden />
      <KNestedFields as="project">
        <KInputText name="name" />
        <KInputText name="id" hidden />
      </KNestedFields>
    </KAddressInput>
  )
}

export default AddressInputs
